import { ICommand } from 'core-ts-types';

const ROOTSTATE: string = 'my.majorexplorer';

const loadMEContentResolve = {
  _studentMajors: (loadStudentCurrentMajorCommand: ICommand) => {
    return loadStudentCurrentMajorCommand();
  },
  _intakeItem: (loadMajorExplorerIntakeCommand: ICommand) => {
    return loadMajorExplorerIntakeCommand();
  }
};

export function MyMajorExplorerRoutes($stateProvider: any) {
  $stateProvider
    .state('my.majorSearch', {
      url: 'search/',
      templateUrl: 'capability-ng-major-explorer/src/views/major_search/major_search.html',
      data: {
        viewTitle: 'Major Search Page',
        hasMainMenu: true,
        ignoredInHistory: false
      }
    })
    .state(ROOTSTATE, {
      url: 'begin/',
      templateUrl: 'capability-ng-major-explorer/src/views/major_survey_begin/major_survey_begin.html',
      controller: 'MajorSurveyBeginController',
      controllerAs: '$ctrl',
      sticky: true,
      data: {
        viewTitle: 'Major Explorer Survey Landing Page',
        forcePathVisibility: false,
        hasMainMenu: true,
        ignoredInHistory: false
      },
      params: {
        fromState: ROOTSTATE
      },
      cache: false,
      resolve: loadMEContentResolve
    })
    .state('my.majorexplorer-step', {
      url: 'step/:pageIndex/',
      templateUrl: 'capability-ng-major-explorer/src/views/major_survey_step/major_survey_step.html',
      controller: 'MajorSurveyStepController',
      controllerAs: '$ctrl',
      resolve: loadMEContentResolve,
      onEnter: (_intakeItem: any, myIntakeModel: any, $stateParams: ng.ui.IStateParamsService) => {
        if (_.isEmpty(myIntakeModel.pages)) {
          myIntakeModel.initialize(_intakeItem);
          myIntakeModel.splitOutRankPage();
        }

        myIntakeModel.setCurrentPageIndex($stateParams.pageIndex);
      },
      data: {
        viewTitle: 'Major Explorer Survey',
        suppressTrackingPage: true,
        ignoredInHistory: false
      },
      params: {
        fromState: ROOTSTATE
      },
      cache: false
    })
    .state('my.majorDetail', {
      url: 'major/detail/:id',
      cache: false,
      templateUrl: 'capability-ng-major-explorer/src/views/major_detail/major_detail.html',
      controller: 'MajorDetailController',
      controllerAs: '$ctrl',
      data: {
        viewTitle: 'Major Explorer Results - Major Detail',
        forcePathVisibility: false,
        ignoredInHistory: false
      },
      params: {
        isFavorite: false
      },
      resolve: {
        chosenMajor: (
          loadMajorDetailCommand: ICommand,
          $stateParams: ng.ui.IStateParamsService,
          $state: ng.ui.IStateService
        ) => {
          return loadMajorDetailCommand($stateParams.id, $stateParams.isFavorite).then((major) => {
            if (_.isEmpty(major)) {
              $state.go(ROOTSTATE);
            } else {
              return major;
            }
          });
        }
      }
    })
    .state('my.majorDetailForced', {
      url: 'major/detail/forced/:id',
      cache: false,
      templateUrl: 'capability-ng-major-explorer/src/views/major_detail/major_detail.html',
      controller: 'MajorDetailController',
      controllerAs: '$ctrl',
      data: {
        viewTitle: 'Major Explorer Results - Major Detail',
        forcePathVisibility: false,
        ignoredInHistory: false
      },
      params: {
        isFavorite: false
      },
      resolve: {
        // Excessive
        // > for mobile
        // we need to pull the major explorer again because the service is empty if we just
        // drop into the view from the new favorites in mobile. This will not be needed once
        // mobile implements Major Explorer in July
        //
        //
        chosenMajor: (
          loadProgramsCommand: ICommand,
          loadMajorDetailCommand: ICommand,
          $stateParams: ng.ui.IStateParamsService
        ) => {
          return loadProgramsCommand().then(() => loadMajorDetailCommand($stateParams.id, $stateParams.isFavorite));
        }
      }
    })
    .state('my.devCourses', {
      url: 'major/devcourses/:id',
      cache: false,
      templateUrl: 'capability-ng-major-explorer/src/views/major_dev_courses/major_dev_courses.html',
      data: {
        viewTitle: 'Developmental Courses',
        ignoredInHistory: false
      },
      resolve: {
        devCourses: (loadDevelopmentalCoursesCommand: ICommand, $stateParams: ng.ui.IStateParamsService) => {
          return loadDevelopmentalCoursesCommand($stateParams.id);
        }
      }
    })
    .state('my.coursemap', {
      url: 'major/coursemap/:id',
      cache: false,
      templateUrl: 'capability-ng-major-explorer/src/views/major_course_map/major_course_map.html',
      controller: 'MajorCourseMapController',
      controllerAs: '$ctrl',
      data: {
        viewTitle: 'Academic Plan',
        ignoredInHistory: false
      },
      params: {
        selectedMajor: undefined
      },
      resolve: {
        courseMap: (loadProgramProgramslotCommand: ICommand, $stateParams: ng.ui.IStateParamsService) => {
          return loadProgramProgramslotCommand($stateParams.id);
        }
      }
    })
    .state('my.placementscores', {
      url: 'placementscores/',
      templateUrl: 'capability-ng-major-explorer/src/views/major_placement_scores/major_placement_scores.html',
      controller: 'MajorPlacementscoresController',
      controllerAs: '$ctrl',
      resolve: {
        placementTestScores: (loadPlacementTestScoresCommand: ICommand) => {
          return loadPlacementTestScoresCommand();
        }
      },
      data: {
        viewTitle: 'Placement Scores',
        ignoredInHistory: false
      }
    })
    .state('my.majorcredentials', {
      url: 'majorcredentials/',
      templateUrl: 'capability-ng-major-explorer/src/views/major_credentials/major_credentials.html',
      data: {
        viewTitle: 'Major Credentials',
        ignoredInHistory: false
      }
    });
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/routes.ts